import React from "react";

const filterStatusValue = (array, keyName, value) => {
  return array?.filter((item) => item[keyName] === value);
};

export default filterStatusValue;
